import { rootApi } from "../../api/rootApi";

export const couponCredentialForTenantApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getCouponCredentialWithLimitOffsetForTenant: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/couponCredential/?limit=${params.limit}&&offset=${params.offset}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    addCouponCredentialForTenant: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/couponCredential/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    updateCouponCredentialForTenant: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/couponCredential/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    updateCouponCredentialStatusForTenant: builder.mutation({
      query: (params) => {
        return {
          method: "PATCH",
          url: `/tenant/couponCredential/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    deleteCouponCredentialForTenant: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/tenant/couponCredential/delete/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
  useAddCouponCredentialForTenantMutation,
  useDeleteCouponCredentialForTenantMutation,
  useGetCouponCredentialWithLimitOffsetForTenantMutation,
  useUpdateCouponCredentialForTenantMutation,
  useUpdateCouponCredentialStatusForTenantMutation,
} = couponCredentialForTenantApi;
